import { memo } from 'react';

import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { booleanSelectOptions } from 'KnmPackage/MainModule/constants/booleanSelectOptions';
import { Row } from 'UIPackage/FormModule/components/Row';

import styles from './ErknmOtherInfo.module.scss';

interface IErknmReturnSelectionProps {
  watchOnly: boolean;
}

export const ErknmReturnSelection = memo(({ watchOnly }: IErknmReturnSelectionProps) => {
  return (
    <Row title="Отметка о возврате товара">
      <SelectInputField
        className={styles.SelectField}
        id="returnSelection"
        name="returnSelection"
        options={booleanSelectOptions}
        size="medium"
        isClearable={false}
        disabled={watchOnly}
      />
    </Row>
  );
});
